import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Runtime configuration for feature toggles that the studio controls without
 * a redeploy — currently just whether ordering is enabled.
 *
 * The value is cached in `sessionStorage` so subsequent pages read it
 * instantly. Falls back to `false` (ordering disabled) on any failure so we
 * never accidentally let a customer submit an order while the flag is off.
 */

const CACHE_KEY = "island-studio-orders-enabled";
export const COMING_SOON_MESSAGE = "Order request options coming soon.";

export function useOrdersEnabled() {
  const [ordersEnabled, setOrdersEnabled] = useState(() => {
    const cached = sessionStorage.getItem(CACHE_KEY);
    return cached === null ? null : cached === "true";
  });

  useEffect(() => {
    let alive = true;
    api
      .get("/config")
      .then(({ data }) => {
        if (!alive) return;
        const enabled = !!data.orders_enabled;
        sessionStorage.setItem(CACHE_KEY, String(enabled));
        setOrdersEnabled(enabled);
      })
      .catch(() => {
        if (!alive) return;
        sessionStorage.setItem(CACHE_KEY, "false");
        setOrdersEnabled(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  // `null` while loading — components can render skeleton/placeholder state.
  return ordersEnabled;
}
